export const brandColors = [
  {
    name: "Primary",
    hex: "#004D40",
    description: "The primary brand color, representing trust and stability.",
  },
  {
    name: "Secondary",
    hex: "#00695C",
    description: "The secondary color, adding depth and sophistication.",
  },
  {
    name: "Tiffany",
    hex: "#0ABAB5",
    description: "A vibrant accent color that conveys luxury and elegance.",
  },
  {
    name: "Purple",
    hex: "#6A0DAD",
    description: "A bold color that signifies creativity and uniqueness.",
  },
  {
    name: "Neutral",
    hex: "#F0F4F8",
    description: "A soft background color that enhances readability.",
  },
  {
    name: "Text",
    hex: "#1A1A1A",
    description: "The primary text color, ensuring clarity and legibility.",
  },
];

export const brandPalette = {
  primary: brandColors[0],
  secondary: brandColors[1],
  accent: [brandColors[2], brandColors[3]],
  neutral: brandColors[4],
  text: brandColors[5],
};

// Export colorData for ColorPalette component
export const colorData = brandColors;

// Export brandValues for BrandValues component
export const brandValues = [
  {
    title: "Luxury & Premium",
    description: "Tiffany Blue leads with sophistication and exclusivity",
    color: "#0ABAB5",
  },
  {
    title: "Authority & Trust",
    description:
      "Sapphire Blue provides legal expertise and professional credibility",
    color: "#0F52BA",
  },
  {
    title: "Cannabis Culture",
    description: "Dank Purple connects authentically with cannabis community",
    color: "#6A0DAD",
  },
  {
    title: "Energy & Attention",
    description:
      "Dank Orange creates urgency and highlights important cannabis offerings",
    color: "#FF6B35",
  },
];
